import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ProviderData } from '@k12/models';
import { FormInlineErrorComponent } from '@k12/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-basic-information',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, FormInlineErrorComponent],
  templateUrl: './basic-information.component.html'
})
export class BasicInformationComponent {
  @Input() formGroup!: FormGroup;
  @Input() providerData!: ProviderData;
}
